<template>

    <div class="modify-frieze-component">

        <div class="inputs-container">

            <div class="input ">
                <p class="text-lg text-center block mb-6 text-primary font-bold">
                    Ajouter un évènement
                </p>

                <div class="flex items-center mb-4">
                    <span class="w-32">Date</span>

                    <input-counter :maxlength="4" :value="decade" class="flex-1">
                        <ion-input v-model="decade" placeholder="Ecris l'année approximative ici"
                                   class="input-custom bg-grey" type="number"
                                   minlength="4" maxlength="4"></ion-input>
                    </input-counter>
                </div>

                <div class="flex mb-4">
                    <span class="w-32 mt-2">Description</span>

                    <input-counter :maxlength="60" :value="inputs['description']" count-method="normal" class="flex-1">
                        <ion-textarea v-model="inputs['description']"
                                      class="input-custom bg-grey" placeholder="Décris l’évènement ici "
                                      maxlength="60"
                                      rows="4"></ion-textarea>
                    </input-counter>
                </div>

                <div class="flex items-center mb-4">
                    <span class="w-32">C'était avec</span>

                    <input-counter :maxlength="30" :value="inputs['with-who']" class="flex-1">
                        <ion-input v-model="inputs['with-who']"
                                   class="input-custom bg-grey"
                                   placeholder="Ecris le nom de la personne avec qui tu l'as partagé"
                                   maxlength="30"></ion-input>
                    </input-counter>
                </div>

                <div class="flex">
                    <span class="w-32 mt-2">Photo</span>

                    <div class="flex-1">
                        <div class="photo-card import">
                            <div class="photo-frame">
                                <div class="photo" :class="{ portrait: isPortrait }" :style="getPhotoBackground">
                                    <button-custom v-if="!photoUrl" shape="round" color="primary" size="md"
                                                   @click="openPhotoAdvice">
                                        Ajouter une photo
                                    </button-custom>
                                    <button-upload v-else :callback="updatePhoto" shape="round" color="primary"
                                                   accept="image/*" class="button-edit2">
                                        <ion-icon :icon="createIcon" slot="icon-only"></ion-icon>
                                    </button-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </div>

        <div class="buttons">
            <button-custom strong shape="round" size="md" color="primary" border @click="confirmCompleted" :loader="loader">
                {{ mode === 'modify' ? "Modifier" : "Ajouter" }}
            </button-custom>
        </div>
    </div>

</template>
<script>
import { IonIcon, IonInput, IonTextarea, } from '@ionic/vue';
import ButtonCustom from "@/components/ButtonCustom";
import ButtonUpload from "@/components/ButtonUpload";
import InputCounter from "@/components/InputCounter";
import { create as createIcon } from 'ionicons/icons';

import openToast from "@/services/ToastService";
import { showFirstError } from "@/services/FormatService";
import { mapGetters } from "vuex";
import { alertBox } from "@/services/AlertService";
import { openModalFeedWall, openModalPhotoAdvice } from "@/services/ModalService";
import { mediaUrl } from "@/services/RoutingService";
import { isPortraitImage } from "@/services/ImageService";

export default {
    name: "ModifyFriezeComponent",
    components: {
        ButtonCustom,
        ButtonUpload,
        IonIcon,
        IonInput,
        InputCounter,
        IonTextarea,
    },
    props: {
        activity: Object,
        data: Object,
        mode: String,
        callback: Function
    },
    data() {
        return {
            createIcon,
            inputs: {},
            decade: null,
            loader: false,
            photo: null,
            isPortrait: false,
        }
    },
    mounted() {
        this.decade = null;
        this.loader = false;
        if (this.activity.decade) {
            this.decade = parseInt(this.activity.decade) + (new Date(this.$store.getters.getHouseUser.birthdate)).getFullYear();
        }
    },
    watch: {
        data: {
            handler(newData) {
                if (!newData) {
                    return;
                }

                for (const [type] of Object.entries(newData)) {
                    // La photo n'est pas un champ texte : elle est gérée à part
                    // et ne doit pas repartir dans le formulaire.
                    if (type === 'photo') {
                        continue;
                    }

                    if (this.activity.data && this.activity.data[type]) {
                        this.inputs[type] = this.activity.data[type];
                    }
                    else {
                        this.inputs[type] = null;
                    }
                }
            },
            immediate: true
        },

        photoUrl: {
            immediate: true,
            handler: function (url) {
                this.detectOrientation(url);
            }
        }
    },

    computed: {
        ...mapGetters([
            'getActivity'
        ]),

        photoUrl: function () {
            if (this.photo) {
                return this.photo.preview;
            }
            if (this.data?.photo) {
                return mediaUrl('activities/' + this.data.photo);
            }
            return null;
        },

        getPhotoBackground: function () {
            if (this.photoUrl) {
                return { 'backgroundImage': 'url(' + this.photoUrl + ')' };
            }
            return null;
        },
    },
    methods: {

        detectOrientation: async function (url) {
            const portrait = await isPortraitImage(url);
            // La photo a pu changer pendant le chargement.
            if (this.photoUrl === url) {
                this.isPortrait = portrait;
            }
        },

        updatePhoto: function (photo) {
            this.photo = photo[0];
        },

        openPhotoAdvice: function () {
            openModalPhotoAdvice(this.updatePhoto);
        },

        /**
         * Sans nouvelle photo on garde l'envoi JSON. Sinon il faut du multipart,
         * et les valeurs vides sont écartées : FormData les convertirait en
         * chaîne "null" que le back enregistrerait telle quelle.
         */
        buildDataPayload: function () {
            if (!this.photo) {
                return this.inputs;
            }

            const formData = new FormData();
            for (const [type, value] of Object.entries(this.inputs)) {
                if (value !== null && value !== undefined && value !== '') {
                    formData.append(type, value);
                }
            }
            formData.append('photo', this.photo.file, this.photo.file.name);

            return formData;
        },

        async saveData() {
            try {
                this.loader = true;
                const response1 = await this.axios.post(
                    'house/' + this.$route.params.house + '/activity/' + this.$route.params.activity + '/data',
                    this.buildDataPayload(),
                    { noLoader: true }
                );
                this.$store.commit('setActivityData', response1.data);

                const age = parseInt(this.decade) - (new Date(this.$store.getters.getHouseUser.birthdate)).getFullYear();

                const response2 = await this.axios.post(
                    'house/' + this.$route.params.house + '/activity/' + this.$route.params.activity + '/decade',
                    { decade: age },
                    { noLoader: true }
                );
                this.$store.commit('setActivity', response2.data);

                await this.axios.post(
                    'house/' + this.$route.params.house + '/activity/' + this.$route.params.activity + '/completed'
                    , { noLoader: true });
                this.$store.commit('setActivity', { completed: true });

                this.loader = false;

            }
            catch (error) {
                openToast(showFirstError(error?.response?.data?.errors));
            }
        },

        async confirmCompleted() {
            if (!this.decade) {
                openToast("Tu dois écrire une date");
                return;
            }
            else if (this.decade < 1900 || this.decade > 2100) {
                openToast("La date n'est pas correcte, elle doit correspondre à une année à 4 chiffres");
                return;
            }
            else if (!this.inputs['description']) {
                openToast("Tu dois écrire une description");
                return;
            }

            await this.saveData(true);

            this.$emit('completed');

            if (!this.activity.shared) {
                const alert = await alertBox("Tu as ajouté un évènement. <br> Souhaites-tu le partager avec tes proches ?",
                    null, 'white',
                    [
                        {
                            text: 'Je ne partage pas',
                            role: 'cancel',
                        },
                        {
                            text: 'Je partage!',
                            role: 'confirm',
                        }]
                );

                if (alert.role === 'confirm') {
                    this.onShare();
                }
            }

        },

        onShare: async function () {
            this.axios.post('house/' + this.$route.params.house + '/activity/' + this.$route.params.activity + '/shared', { noLoader: true })

            const alert = await alertBox("Tu as partagé l’évènement avec tes proches ! <br><br>Une notification a été postée sur le groupe de ta famille",
                null, 'white',
                [
                    {
                        text: 'Super !',
                        role: 'cancel',
                        cssClass: 'primary'
                    },
                    {
                        text: 'Aller sur le groupe',
                        role: 'confirm',
                        cssClass: 'outline-primary'
                    }]
            );

            if (alert.role === 'confirm') {
                this.onOpenModalFeed();
            }
        },

        onOpenModalFeed: function () {
            openModalFeedWall();
        },

    }
}
</script>

<style lang="scss" scoped>

.modify-frieze-component {

    @apply w-full flex-1;

    .inputs-container {
        max-width: 70%;
        @apply mx-auto flex flex-col pt-4 pb-20;

        .photo-card.import {
            @apply mx-0 mb-0 items-start;

            // Le cadre par défaut fait 500px : trop large pour la colonne du
            // formulaire, qui partage la largeur avec le libellé.
            .photo-frame {
                width: 300px;

                .photo {
                    @apply border-[8px];
                }
            }
        }

        .input {
            @apply relative px-12 pt-3 pb-10 rounded-2xl shadow-2xl mb-10 bg-white;

            &.sm {
                max-width: 300px;
            }

            &.xs {
                max-width: 200px;
            }
        }
    }

    .buttons {
        @apply text-center space-x-24 fixed bottom-4 left-0 right-0 z-10;
    }
}

</style>
